module.exports = __webpack_public_path__ + "static/img/6-title.d3c575a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/layer4/6-title.png
// module id = YGyd
// module chunks = 0